import ModalVideo from 'modal-video';

new ModalVideo('.js-video-button');